export const VERSION = typeof "3.4.11" !== 'undefined' ? "3.4.11" : 'latest';
//# sourceMappingURL=version.js.map